
import {
  InformationCircleIcon,
  QrCodeIcon,
  DocumentTextIcon,
  UserCircleIcon
} from '@heroicons/react/24/outline'
import { useLocation,Link } from 'react-router-dom';
import {useSelector} from "react-redux";
import type {RootState} from "../Store";

export default function Footer() {
  const location = useLocation();
  const hideComponent = location.pathname === '/cart/1/pour/1';
  const data = useSelector((state: RootState) => state);

  return (
      <footer className="bg-second-bg sticky py-4 z-50" style={{display: hideComponent ? 'none' : 'block'}}>
        <div className='flex flex-row justify-between text-white'>
          <a className='w-1/4 flex items-center justify-center' href="/"><QrCodeIcon height={30}/></a>
          <Link className='w-1/4 flex items-center justify-center' to="/order"><DocumentTextIcon height={30}/></Link>
          <a className='w-1/4 flex items-center justify-center' href="/user"><UserCircleIcon height={30}/>
            <strong className='p-1'>{data.user.credit > 0 && <span className='bg-red-500 text-white rounded-full text-xs p-1'>${data.user.credit.toFixed(2)}</span>}</strong></a>
          <Link className='w-1/4 flex items-center justify-center' to="/info"><InformationCircleIcon height={30}/></Link>
        </div>
      </footer>
  )
}
